import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {DateTime} from 'luxon';

@Component({
  selector: 'vdw-shift',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShiftComponent {
  public start = input.required<string>();
  public end = input.required<string>();
  public name = input<string>();

  public getStartOnDate(date: DateTime): DateTime {
    const [startHours, startMinutes] = this.getTimeAsNumeric(this.start());

    return this.getDateWithTime(date, startHours, startMinutes);
  }

  public getEndOnDate(date: DateTime): DateTime {
    const [endHours, endMinutes] = this.getTimeAsNumeric(this.end());
    return this.getDateWithTime(date, endHours, endMinutes);
  }

  public getTimeAsNumeric(time: string): [number, number] {
    const [hours, minutes] = time.split(':').map((s: string) => Number(s));
    return [hours, minutes];
  }

  private getDateWithTime(date: DateTime, hours: number, minutes: number): DateTime {
    return date.set({hour: hours}).set({minute: minutes});
  }
}
